// DEPRECATEME: since [Release 22]
import React from 'react';

import PropTypes from 'prop-types';

import { VFBanner } from '@vfgroup-oneplatform/foundation/Components';

const ProductsAndServicesTab = ({ TabComponent, pageBannerProps, withPageBanner, ...tabProps }) => {
  return (
    <>
      {withPageBanner && <VFBanner {...pageBannerProps} />}
      <TabComponent {...tabProps} />
    </>
  );
};

ProductsAndServicesTab.propTypes = {
  TabComponent: PropTypes.object,
  pageBannerProps: PropTypes.shape({
    backgroundColors: PropTypes.array,
    title: PropTypes.string,
    description: PropTypes.string,
    primaryButtonTitle: PropTypes.string,
    secondaryButtonTitle: PropTypes.string,
    onPrimaryButtonPress: PropTypes.func,
    onSecondaryButtonPress: PropTypes.func,
    withSecondaryButton: PropTypes.bool,
  }),
  withPageBanner: PropTypes.bool,
};

export default ProductsAndServicesTab;
// End deprecation
